
























import Modal from '@/components/Modal.vue'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  components: { Modal }
})
export default class DeletePaymentMethodErrorModal extends Vue {
}
